import NiceModal from "@ebay/nice-modal-react";
import P from "components/P";
import FlexChild from "layouts/flex/FlexChild";
import VerticalFlex from "layouts/flex/VerticalFlex";
import Center from "layouts/wrapper/Center";
import PaddingWrapper from "layouts/wrapper/PaddingWrapper";
import ModalBase from "modals/base/ModalBase";
import { useRef } from "react";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { fas } from "@fortawesome/free-solid-svg-icons";
import HorizontalFlex from "layouts/flex/HorizontalFlex";

const LogoutConfirmModal = NiceModal.create(
    (props) => {
        const { t } = useTranslation();
        const [withHeader, withFooter] = [false, false];
        const [width, height] = ["min(90%, 380px)", "auto"];
        const withCloseButton = false;
        const clickOutsideToClose = true;
        const title = "";
        const buttonText = t("close");

        const modal = useRef();

        const onConfirmClick = async () => {
            if (props.onConfirm) {
                
                let isAsyncFn = props.onConfirm.constructor.name === "AsyncFunction" ? true : false;
                if (isAsyncFn) {
                    await props.onConfirm().then((result) => {
                        modal.current.close();
                    });
                } else {
                    props.onConfirm();
                    modal.current.close();
                }
            }else{
                modal.current.close();
            }
        }

        const onCancelClick = () => {
            if (props.onCancel) {
                props.onCancel();
            }else{

            }
            modal.current.close();
        }

        return (
            <ModalBase 
                ref={modal} 
                width={width} 
                height={height} 
                withHeader={withHeader} 
                withFooter={withFooter} 
                withCloseButton={withCloseButton} 
                clickOutsideToClose={clickOutsideToClose} 
                title={title} 
                buttonText={buttonText}
                backgroundColor="#ffffff"
                borderRadius="16px"
                padding="0"
            >
                <div style={{
                    background: "#ffffff",
                    borderRadius: "16px",
                    overflow: "hidden",
                    boxShadow: "0 20px 40px rgba(0, 0, 0, 0.1)",
                    position: "relative"
                }}>
                    {/* 헤더 영역 */}
                    <div style={{
                        padding: "32px 24px 24px 24px",
                        textAlign: "center",
                        background: "#ffffff"
                    }}>
                        {/* 로그아웃 아이콘 */}
                        <div style={{
                            width: "64px",
                            height: "64px",
                            background: "linear-gradient(135deg, #ff6b6b, #ff8e8e)",
                            borderRadius: "50%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            margin: "0 auto 20px auto",
                            boxShadow: "0 8px 20px rgba(255, 107, 107, 0.3)"
                        }}>
                            <FontAwesomeIcon 
                                icon={fas.faSignOutAlt} 
                                style={{ 
                                    fontSize: "28px", 
                                    color: "#ffffff"
                                }} 
                            />
                        </div>

                        {/* 메시지 */}
                        <P 
                            size={20} 
                            weight={700} 
                            color="#333333"
                            style={{ 
                                marginBottom: "8px",
                                lineHeight: "1.4"
                            }}
                        >
                            {props.message || "로그아웃 하시겠습니까?"}
                        </P>

                        <P 
                            size={14} 
                            color="#666666"
                            style={{ 
                                lineHeight: "1.5",
                                marginTop: "8px"
                            }}
                        >
                            현재 세션이 종료됩니다.
                        </P>
                    </div>

                    {/* 버튼 영역 */}
                    <div style={{
                        padding: "0 24px 32px 24px",
                        background: "#ffffff"
                    }}>
                        <HorizontalFlex gap={12}>
                            {/* 취소 버튼 */}
                            <FlexChild>
                                <button
                                    onClick={onCancelClick}
                                    style={{
                                        width: "100%",
                                        padding: "14px 20px",
                                        background: "#f8f9fa",
                                        border: "1px solid #e9ecef",
                                        borderRadius: "12px",
                                        color: "#495057",
                                        fontSize: "16px",
                                        fontWeight: "600",
                                        cursor: "pointer",
                                        transition: "all 0.2s ease",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        gap: "6px"
                                    }}
                                    onMouseEnter={(e) => {
                                        e.target.style.background = "#e9ecef";
                                        e.target.style.transform = "translateY(-1px)";
                                    }}
                                    onMouseLeave={(e) => {
                                        e.target.style.background = "#f8f9fa";
                                        e.target.style.transform = "translateY(0)";
                                    }}
                                >
                                    <FontAwesomeIcon icon={fas.faTimes} style={{ fontSize: "14px" }} />
                                    {props.cancelText || "취소"}
                                </button>
                            </FlexChild>

                            {/* 확인 버튼 */}
                            <FlexChild>
                                <button
                                    onClick={onConfirmClick}
                                    style={{
                                        width: "100%",
                                        padding: "14px 20px",
                                        background: "linear-gradient(135deg, #ff6b6b, #ff8e8e)",
                                        border: "none",
                                        borderRadius: "12px",
                                        color: "#ffffff",
                                        fontSize: "16px",
                                        fontWeight: "600",
                                        cursor: "pointer",
                                        transition: "all 0.2s ease",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        gap: "6px",
                                        boxShadow: "0 4px 12px rgba(255, 107, 107, 0.3)"
                                    }}
                                    onMouseEnter={(e) => {
                                        e.target.style.transform = "translateY(-1px)";
                                        e.target.style.boxShadow = "0 6px 16px rgba(255, 107, 107, 0.4)";
                                    }}
                                    onMouseLeave={(e) => {
                                        e.target.style.transform = "translateY(0)";
                                        e.target.style.boxShadow = "0 4px 12px rgba(255, 107, 107, 0.3)";
                                    }}
                                >
                                    <FontAwesomeIcon icon={fas.faSignOutAlt} style={{ fontSize: "14px" }} />
                                    {props.confirmText || "로그아웃"}
                                </button>
                            </FlexChild>
                        </HorizontalFlex>
                    </div>
                </div>
            </ModalBase>
        );
    }
);

export default LogoutConfirmModal;